import { useState } from "react"
import { singletonHook } from "react-singleton-hook"

const init = {}
let currentProfile = init
let globalSetProfile = () => {}

export const useUserProfile = singletonHook(init, () => {
  const [profile, setProfile] = useState(currentProfile)
  globalSetProfile = setProfile
  currentProfile = profile
  return currentProfile
})

export const UserProfile = ({ children }) => {
  let profile = useUserProfile()
  return children(profile)
}

export const setUserProfile = (profile) => {
  currentProfile = profile
  return globalSetProfile(profile)
}
